<template>
  <div class="payBookDadilog">
    <div class="box">
      <div class="box-title">需求填写</div>
      <div class="box-list">
        <el-form
          :model="dataObj"
          ref="dataObjForm"
          label-width="0px"
          class="demo-ruleForm"
          :rules="rules"
        >
          <p>联系电话</p>
          <el-form-item prop="mobile">
            <el-input
              v-model="dataObj.mobile"
              placeholder="请输入联系电话"
            ></el-input>
          </el-form-item>
          <p>联系人</p>
          <el-form-item prop="name">
            <el-input
              v-model="dataObj.name"
              placeholder="请输入联系人"
            ></el-input>
          </el-form-item>
          <p>具体需求</p>
          <el-form-item prop="note">
            <el-input
              v-model="dataObj.note"
              type="textarea"
              :rows="5"
            ></el-input>
          </el-form-item>
          <div class="button-box" @click="submitForm('dataObjForm')">
            立即提交需求
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { needPurchase } from "@/api/api.js";

export default {
  data() {
    const checkAge = (rule, value, callback) => {
      let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (value === "") {
        callback(new Error("手机号不能为空"));
      } else if (!myreg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    return {
      dataObj: {
        name: "",
        mobile: "",
        note: "",
        periodicalId: ""
      },
      rules: {
        name: [{ required: true, message: "名字不能为空" }],
        mobile: [{ validator: checkAge, trigger: "blur" }],
        note: [{ required: false }]
      }
    };
  },
  mounted() {
    this.getData(this.$route.query.id);
  },
  methods: {
    getData(val) {
      if (val) {
        this.dataObj.periodicalId = val;
      } else {
        this.$router.push({ name: "H5book" });
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.needPurchase();
        } else {
          return false;
        }
      });
    },
    needPurchase() {
      needPurchase(this.dataObj).then(res => {
        if (res.code === 0) {
          this.$message({
            message: "保存成功",
            type: "success"
          });
          this.$router.push({ name: "H5book" });
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    }
  }
};
</script>

<style lang="less">
.payBookDadilog {
  width: 100%;
  height: 100%;
  .box {
    box-sizing: border-box;
    padding: 16px;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 1);
    border-radius: 10px;
    &-title {
      width: 100%;
      height: 100%;
      text-align: left;
      line-height: 50px;
      font-size: 18px;
      font-weight: bold;
      color: #343434;
      letter-spacing: 4px;
      border-radius: 10px 10px 0px 0px;
      .el-icon-close {
        position: absolute;
        right: 20px;
        top: 20px;
        cursor: pointer;
      }
    }
  }
  .box-list {
    // padding: 30px;
    box-sizing: border-box;
    p {
      font-size: 16px;
      color: rgba(52, 52, 52, 1);
      line-height: 28px;
      margin-bottom: 10px;
    }
    .button-box {
      margin: 0 auto;
      width: 100%;
      height: 44px;
      background: rgba(108, 44, 102, 1);
      border-radius: 22px;
      font-size: 16px;
      text-align: center;
      color: rgba(255, 255, 255, 1);
      line-height: 44px;
    }
  }
}
</style>
